import React from 'react'
import PropTypes from 'prop-types'
import ErrorDisplay from '../ErrorDisplay'
import './SignUpForm.css'
import 'font-awesome/css/font-awesome.css'

/**
 * A react component that displays a form that can be use to create a new user account
 */
const SignUpForm = (props) => {
	const submit = (evt) => {
		evt.preventDefault()
		props.submit(props.username, props.password, props.email)
	}

	const usernameChanged = (evt) => {
		props.usernameChanged(evt.target.value)
	}

	const passwordChanged = (evt) => {
		props.passwordChanged(evt.target.value)
	}

	const emailChanged = (evt) => {
		props.emailChanged(evt.target.value)
	}

	return (
		<form className="form" onSubmit={submit}>
			<p className="field">
        <input className="username"
               type="text"
               onChange={usernameChanged}
               value={props.username}
               placeholder="username"
               name="username"
               id="signUp_username"
               disabled={props.disabled}/>
				<i className="fa fa-user fa-lg"/>
			</p>
			<p className="field">
        <input className="email"
               type="text"
               onChange={emailChanged}
               value={props.email}
               placeholder="email"
               name="email"
               id="signUp_email"
               disabled={props.disabled}/>
				<i className="fa fa-envelope fa-lg"/>
			</p>
			<p className="field">
        <input className="password"
               type="password"
               onChange={passwordChanged}
               value={props.password}
               placeholder="password"
               name="password"
               id="signUp_password"
               disabled={props.disabled}/>
				<i className="fa fa-lock fa-lg"/>
			</p>
			<p className="submit">
				<button className="submitLogIn" type="submit" disabled={props.disabled}>
					<i className="fa fa-arrow-right fa-lg"/>
				</button>
			</p>
			<ErrorDisplay err={props.err}/>
		</form>
	)
}

SignUpForm.propTypes = {
	/** The user's name for the login */
	username: PropTypes.string.isRequired,
	/** The user's email address */
	email: PropTypes.string.isRequired,
	/** The user's password for the login */
	password: PropTypes.string.isRequired,
	/** The function to call to submit credentials for authentication */
	submit: PropTypes.func.isRequired,
	/** The function to call when the username is changed */
	usernameChanged: PropTypes.func.isRequired,
	/** The function to call when the email address is changed */
	emailChanged: PropTypes.func.isRequired,
	/** The function to call when the password is changed */
	passwordChanged: PropTypes.func.isRequired,
	/** If set to true, the form fields and buttons are disabled */
	disabled: PropTypes.bool.isRequired
}

export default SignUpForm


// WEBPACK FOOTER //
// ./src/components/SignUpForm/SignUpForm.js